import React from 'react';
import { motion } from 'framer-motion';
export function SurvivorBenefitSection() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.8
  }} className="my-12 pl-6 border-l-4 border-[#1B2A4A]/20" data-id="element-210">
      <div className="space-y-6 text-lg md:text-xl text-[#1B2A4A]" data-id="element-211">
        <p className="font-bold" data-id="element-212">
          Here&apos;s what most men don&apos;t realize until it&apos;s too late:
        </p>
        <p data-id="element-213">
          When you claimed early, you didn&apos;t just cut YOUR check. You cut
          your wife&apos;s survivor benefit too.
        </p>
        <p className="italic text-[#1B2A4A]/80" data-id="element-214">
          If you pass away first — and statistically, you probably will — she
          gets stuck with YOUR reduced amount for the rest of HER life.
        </p>
        <p data-id="element-215">
          Every single one of these three exits can increase the check
          she&apos;ll depend on when you&apos;re gone.
        </p>
      </div>
    </motion.section>;
}